import { VisuallyHidden } from '../VisuallyHidden';
import styles from './Spinner.module.scss';

type Props = {
  /**
   * Accessibility label for the node. Pass an empty string to omit the
   * visually-hidden label when the spinner is wrapped in another labelled
   * element (e.g. inside a `<ProgressBar>`).
   * @default 'Loading'
   * */
  'aria-label'?: string;
  /** Diameter and border width of loader. */
  size?: 'small' | 'medium' | 'large';
  /** The color of the spinner. Use `light` when rendering over a dark background. Use `dark` when rendering over a light background. */
  color?: 'light' | 'dark';
};

/**
 * Renders a spinning loading indicator, used to inform the user they're waiting
 * for an action to complete.
 */
export const Spinner = ({
  'aria-label': ariaLabel = 'Loading',
  color = 'dark',
  size = 'small',
}: Props) => {
  return (
    <div
      className={styles.root}
      data-testid="spinner"
      role="status"
      data-zds
      data-color={color}
      data-size={size}
    >
      {ariaLabel && <VisuallyHidden>{ariaLabel}</VisuallyHidden>}
    </div>
  );
};
